import { withKey, withoutKey, type GlobalStateContext } from 'piral-core'
import type { PageTopRegistration } from './PageTopApi'

export function registerPageTopItem(ctx: GlobalStateContext, name: string, value: PageTopRegistration) {
  ctx.dispatch((state) => ({
    ...state,
    registry: {
      ...state.registry,
      pageTopItems: withKey(state.registry.pageTopItems, name, value)
    }
  }))
}

export function unregisterPageTopItem(ctx: GlobalStateContext, name: string) {
  ctx.dispatch((state) => ({
    ...state,
    registry: {
      ...state.registry,
      pageTopItems: withoutKey(state.registry.pageTopItems, name)
    }
  }))
}
